<template>
  <div
    class="SelectInput"
    :class="{ 'has-error': !!errorMessage, success: meta.valid }"
  >
    <label :for="name">{{ label }}</label>

    <select
      class="form-control"
      :name="name"
      :id="name"
      @input="handleChange"
      @blur="handleBlur"
    >
      <option value="">{{ placeholder }}</option>

      <option
        v-for="(option, index) in options"
        :key="index"
        :selected="option === value"
      >
        {{ option }}
      </option>
    </select>

    <p class="help-message" v-show="errorMessage || meta.valid">
      {{ errorMessage || successMessage }}
    </p>
  </div>
</template>

<script>
import { useField } from "vee-validate";

export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    successMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(props.name, undefined, {
      initialValue: props.value,
    });

    return {
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
    };
  },
};
</script>

<style scoped>
.SelectInput {
  position: relative;
  margin-bottom: calc(1em * 1.5);
  width: 100%;
}

label {
  display: block;
  margin-bottom: 4px;
  width: 100%;
}

select {
  border-radius: 5px;
  border: 2px solid transparent;
  padding: 5px 10px;
  outline: none;
  background-color: #f2f5f7;
  width: 100%;
  transition: border-color 0.3s ease-in-out, color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

select:focus {
  border-color: var(--primary-color);
}

.help-message {
  position: absolute;
  bottom: calc(-1.5 * 1em);
  left: 20px;
  margin: 0;
  font-size: 14px;
}

.SelectInput.has-error select {
  background-color: var(--error-bg-color);
  color: var(--error-color);
}

.SelectInput.has-error select:focus {
  border-color: var(--error-color);
}

.SelectInput.has-error .help-message {
  color: var(--error-color);
}

.SelectInput.success select {
  background-color: var(--success-bg-color);
  color: var(--success-color);
}

.SelectInput.success select:focus {
  border-color: var(--success-color);
}

.SelectInput.success .help-message {
  color: var(--success-color);
}
</style>
